<script>
import {WO_STATUS_TO_BE_ASSIGNED, WO_STATUS_COMPLETED,WO_STATUS_CANCELLED, WorkOrderStatus, WO_TYPE_EQUIPMENT_MAINTENANCE,WO_TYPE} from '@/config/common'
import _ from 'lodash'
import BusinessCard from "@/views/work-order/components/widgets/business-card";
import {customerDetail, editWorkOrder, checkin, addCheckin, editCheckin, deleteCheckin, getSiteRecord, getSiteDescription, getCustomerContactDetail,
  createCustomerFeedback,
  getCustomerDeviceContact,
  getCustomerContacts
} from "@/service";
import { getCompany, getEngineer, getDeviceInfo } from "@/helpers/common-service";
import SetCompanyModal from "@/views/work-order/components/edit/set-company-modal";
import SetEngineerModal from "@/views/work-order/components/edit/set-engineer-modal";
import AddWorkSite from "@/views/work-order/components/add-work-site";
import AddSiteDescription from "@/views/work-order/components/add-site-description";
import EditableField from "@/views/work-order/components/widgets/editable-field";
import CheckedRadio from "@/views/work-order/components/widgets/checked-radio";
import CustomerTextarea from "@/views/work-order/components/widgets/customer-textarea";
import UploadWithPreview from "@/views/widgets/upload-files/upload-with-preview";
import {addressText, formatDatetime} from "@/helpers/common";
import showAvatar from "@/views/widgets/show-avatar";
import WoContentEditable from "@/views/work-order/components/widgets/wo-content-editable.vue";
import addUpdateAccountDialog from './addUpdateAccountDialog.vue' // 添加联系人弹窗


import {
        // alertComfirm,
        // successMsg,
        errorMsg
    } from "@/helpers/swal";
import {
  isWorkOrderToBeConfirmed,
  isWorkOrderToBeConstruction,
  isWorkOrderToBeReassigned,
  isWorkOrderUnderConstruction,
  isWorkOrderCompleted
} from "@/views/work-order/wo-status-op";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    woData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  emits:["checkinLoaded","refresh","confirmOrder"],
  data () {
    return {
      WO_TYPE,
      WO_TYPE_EQUIPMENT_MAINTENANCE,
      WO_STATUS_COMPLETED,
      WO_STATUS_CANCELLED,
      serviceCompanyList: [],
      engineerList: [],
      currentCustomer: {},
      currentCompanyId: null,
      currentCompany: {},
      currentMainEngineerId: null,
      currentMainEngineer: {},
      currentAssistEngineerId: null,
      currentAssistEngineer: {},
      showCompanySet: false,
      showEngineerSet: false,
      engineerTypeInModal: '',
      attachmentList: [],
      checkins: [],
      // 签到记录
      checkin: {},
      // 施工现场
      workSite: [],
      //现场情况说明
      siteDescription:[],
      // 设备信息
      deviceInfo: {},
      deviceRootSn: null,
      // 联系人详情
      customerContact: {},
      // 维保项目可选项s
      maintainOptions: [],
      // currentGroupSn: null,
      feedBackForm: {
        quality: 0,
        attitude: 0,
        response_speed: 0,
        content: '',
        work_order: null,
      },
      rateTexts: [
        this.$t('page.rate.0'),
        this.$t('page.rate.1'),
        this.$t('page.rate.2'),
        this.$t('page.rate.3'),
        this.$t('page.rate.4'),
        this.$t('page.rate.5'),
      ],
      showFeedbackForm: false,
      //新建联系人
      addUpdateAccountDialogInfo:{},
      //新建&修改按钮状态
      isAddEdit:false,
      contactPerson: '', //当前设备联系人
      userOptions: [], //客户联系人列表
      modalTitle:'',
      userModal:false,
      specialStatus:false,
      editFieldName:'',//编辑状态下的字段
      currentStatusOptions:[
        { label:this.$t('page.work-order.current-status.finished'), value:1 },
        { label:this.$t('page.work-order.current-status.further_visit_necessary'), value:2 }
      ],
      //派工再次确认
      planDate:{
        plan_start_at:null,
        plan_end_at:null,
      },
      flatpickrConfig: {
        enableTime: false,
        dateFormat: "Y-m-d",
        time_24hr: false,
        inline: false,
        // wrap: false,
      },
    }
  },
  validations: {
    planDate: {
      plan_start_at: { required },
      plan_end_at:{ required }
    }
  },
  mounted(){
    this.getCustomerContacts()
  },
  computed: {
    showMaintainInput() {
      return this.woData.type == WO_TYPE_EQUIPMENT_MAINTENANCE;
    },
    feedbackExist() {
      return this.woData.feedback && this.woData.feedback.quality
    },
    statusArr() {
      if (this.woData.status == 4) {
        return [this.$t('page.canceled')]
      }
      return [this.$t('page.dispatched'), this.$t('page.construction'), this.$t('page.completedWorkOrder')]
    },
    statusNow() {
      let current = _.find(WorkOrderStatus, ['value', parseInt(this.woData.status)])
      if (current) {
        if (current['label'] == this.$t('page.completed')) {
          return this.$t('page.completedWorkOrder')
        }
        return current['label'].replace(this.$t('page.processWait'), '')
      }

      return ''
    },
    editable() {
      // 工单取消或完成后，都不让修改了
      return [1, 2].includes(parseInt(this.woData.status))
    },
    /**
     *   1. 工单状态：待派工、待确认、待转派、待施工时：

          – – 厂商角色进入详情页，可以正常操作切换按钮、删除按钮；

          – – 代理商角色进入详情页，屏蔽切换按钮，显示删除按钮；
      2.工单状态：施工中、已完成、已取消、进入详情页，服务公司屏蔽切换按钮、删除按钮
     * / 
    /* 该工单是从服务请求或者保养是计划 */ 
    editableStatus(){
      let flag = false
      if(this.woData.status == WO_STATUS_TO_BE_ASSIGNED ||   //待派工
        isWorkOrderToBeConfirmed(this.woData)|| //待确认
        isWorkOrderToBeReassigned(this.woData) || //待转派
        isWorkOrderToBeConstruction(this.woData) //待施工
        ){

          if(this.user.user_type === 'manufacturer'){ //厂商
            flag  = true
          }else if(this.user.user_type === 'service_company'){//代理商
            this.serviceCompanyDel()
            flag = false
          }

        }else if(isWorkOrderUnderConstruction(this.woData) || //施工中
            this.woData.status == WO_STATUS_COMPLETED||//已完成
            this.woData.status == WO_STATUS_CANCELLED){//已取消
              flag = false
          }


      return flag
    },
    taskServiceRequest(){
      let flag = true
      if(this.woData.task_id || this.woData.service_request){
        flag = false
      }
      return flag;
    },

    // 其他信息是否有编辑权限
    otherInfoEditPerm() {
      //工单状态是已完成时,不能编辑。
      return !isWorkOrderCompleted(this.woData) &&this.hasPermissionFor('order.other.patch')
    },
    user() {
        return JSON.parse(localStorage.getItem("user"));
    },
    /* 控制服务评价是否可以评论:普通工单是已完成可查看 */ 
    isServiceEvaluation(){
      let flag = false
      // if((this.woData.status == WO_STATUS_COMPLETED)&&(this.user.user_type === 'customer')){
        if(this.woData.status == WO_STATUS_COMPLETED&&this.woData.is_rating){
        flag = true
      }
      return flag;
    }
  },
  methods: {
    addressText,
    formatDatetime,
    isWorkOrderCompleted,
    /* 代理商符合权限，不是2种类型工单转来，可展示删除按钮 */ 
    serviceCompanyDel(){
      if(this.hasPermissionFor('order.company.patch') && this.taskServiceRequest){
        this.specialStatus = true
      }
    },
    getStatusProgressClass(val) {
      let activeIndex = this.statusArr.indexOf(this.statusNow)
      let index = this.statusArr.indexOf(val)
      if (activeIndex === this.statusArr.length - 1) {
        return 'done'
      }
      if (activeIndex == index) {
        return 'active'
      }
      if (activeIndex > index) {
        return 'done'
      }
      return 'waiting'
    },
    getStatusText(val) {
      if (this.getStatusProgressClass(val) == 'active' && ![this.$t('page.canceled'), this.$t('page.completedWorkOrder')].includes(val)) {
        if (val === this.$t('page.dispatched') && !this.woData.main_engineer && !this.woData.is_confirm) {
          return val + `(${this.$t('page.workOrderProcessing')})`
        }
        else if (val === "派工" && this.woData.main_engineer && !this.woData.is_confirm) {
          return val + `(${this.$t('page.toBeConfirmed')})`
        }
        else {
          return val + `(${this.$t('page.workOrderProcessing')})`
        }
      }
      return val
    },
    // 添加或切换服务商
    editCompanyCommit(id) {
      const form = {
        id: this.woData.id,
        service_company: id,
        status: 1
      }
      // 如果服务商变了，提交修改，清空工程师
      if (this.woData.service_company != form.service_company) {
        form['main_engineer'] = null
        form['assist_engineer'] = null
        form['is_reassign'] = false
        // this.clearCheckin()
        this.edit(form)
      }
      this.showCompanySet = false
    },
    // 添加或切换工程师
    openEngineerSet(type = '') {
      if (type) {
        this.engineerTypeInModal = type
      } else if (!this.currentMainEngineerId) {
        this.engineerTypeInModal = 'main'
      } else if (!this.currentAssistEngineerId) {
        this.engineerTypeInModal = 'assist'
      } else {
        console.log('type no value')
        return
      }
      this.showEngineerSet = true
    },
    engineerChanged(value) {
      this.showEngineerSet = false
      const form = {
        id: this.woData.id,
        status: 1,
        is_reassign: false
      }
      if (this.engineerTypeInModal == 'main' && this.woData.main_engineer != value) {
        form['main_engineer'] = value
        // 清空原工程师的签到记录
        // this.clearCheckin(this.woData.main_engineer)
        this.edit(form)
      }
      if (this.engineerTypeInModal == 'assist' && this.woData.assist_engineer != value) {
        form['assist_engineer'] = value
        // 清空原工程师的签到记录
        // this.clearCheckin(this.woData.assist_engineer)
        this.edit(form, false, false)
      }
    },
    // 删除工程师
    deleteEngineer(type) {
      const form = {
        id: this.woData.id
      }
      if (type == 'main') {
        this.currentMainEngineerId = null
        form['main_engineer'] = null
        // 清空原工程师的签到记录
        // this.clearCheckin(this.woData.main_engineer)
      }
      if (type == 'assist') {
        this.currentAssistEngineerId = null
        form['assist_engineer'] = null
        // 清空原工程师的签到记录
        // this.clearCheckin(this.woData.assist_engineer)
      }
      // 如果没有服务商或者没有工程师，变成待派工
      if (!this.currentCompanyId || (!this.currentMainEngineerId && !this.currentAssistEngineerId)) {
        form['status'] = WO_STATUS_TO_BE_ASSIGNED
      }
      this.edit(form, false, true)
    },
    // 删除服务商
    deleteCompany() {
      this.currentCompanyId = null
      const form = {
        id: this.woData.id,
        service_company: null,
        status: 1,
        main_engineer: null,
        assist_engineer: null,
        is_reassign: false,
      }
      // 清空签到记录
      // this.clearCheckin()
      this.edit(form)
    },
    // 获取服务商
    getCompany() {
      getCompany().then(res => {
        this.serviceCompanyList = res
        if (this.currentCompanyId) {
          this.currentCompany = _.find(res, ['id', this.currentCompanyId]) || {}
        } else {
          this.currentCompany = {}
        }
      })
    },
    getEngineer(companyId) {
      getEngineer(companyId).then(res => {
        this.engineerList = res
        if (this.currentMainEngineerId) {
          this.currentMainEngineer = _.find(res, ['id', this.currentMainEngineerId]) || {}
        } else {
          this.currentMainEngineer = {}
        }
        if (this.currentAssistEngineerId) {
          this.currentAssistEngineer = _.find(res, ['id', this.currentAssistEngineerId]) || {}
        } else {
          this.currentAssistEngineer = {}
        }
      })
    },
    getCustomerDetail() {
      customerDetail(this.woData.customer)
          .then(res => {
        this.currentCustomer = res.payload
      })
    },
    // 获取设备信息
    getDeviceInfo(root_sn) {
      getDeviceInfo(root_sn, false, false, true).then(res => {
        this.deviceInfo = res
        if (this.woData.type == WO_TYPE_EQUIPMENT_MAINTENANCE) {
          this.maintainOptions = this.deviceInfo.repairs.filter(item => item.name == this.woData.maintain_name)
        } else {
          this.maintainOptions = []
        }
      })
    },
    // 获取签到记录
    getCheckin() {
      // 只取一个最新的签到记录
      checkin({
        work_order:this.woData.id,
        page_size: 1,
        page:1,
        ordering: '-check_in_time',
      }).then(res => {
        const checkin = _.get(res, 'payload.results', [])
        this.checkins = checkin
        this.$emit('checkinLoaded', checkin)
        if (checkin.length) {
          this.checkin = checkin[0]
        } else {
          this.checkin = {}
        }

      })
    },
    // 清空签到记录
    clearCheckin(engineerId) {
      this.checkins.forEach(checkin => {
        if (engineerId && checkin.engineer != engineerId) return
        deleteCheckin(checkin.id)
      })
      this.checkins = []
      this.checkin = {}
    },
    // 获取施工现场
    getWorkSite() {
      getSiteRecord({
        work_order: this.woData.id,
        page_size: 0,
        ordering: '-created_at',
      }).then(res => {
        this.workSite = []
        let ws = []
        for (let i = 0; i < res.payload.length; i++) {
          const attachment = res.payload[i].attachment.map((item) => {
            return {
              ...item,
              content: res.payload[i].content
            }
          })
          ws = _.concat(ws, attachment)
        }
        this.workSite = ws
      })
    },
    //获取现场情况说明
    getSiteDescriptionInfo(){
      getSiteDescription({
        work_order: this.woData.id,
        page_size: 0,
        ordering: '-created_at',
      }).then(res => {
        this.siteDescription = []
        let ws = []
        for (let i = 0; i < res.payload.length; i++) {
          const attachment = res.payload[i].attachment.map((item) => {
            return {
              ...item,
              content: res.payload[i].content
            }
          })
          ws = _.concat(ws, attachment)
        }
        this.siteDescription = ws
      })
    },
    // 编辑工单字段
    editField(e,fieldName) {
      
      this.editFieldName = fieldName
      const form = {
        id: this.woData.id,
      }
      form[fieldName] = e
      // 如果修改客户，清空设备（设备是关联在客户下的，如果重新改客户，要重新选设备）
      if (fieldName === 'customer' && e != this.woData.customer) {
        form['device_root_sn'] = null
        form['device_name'] = null
        this.deviceInfo = {}
        this.deviceRootSn = null
        form['customer_contact'] = null
      }
      /* 设备保养状态----维护项目选项 */
      if (fieldName === 'type') {
        form['save_maintain_item_ids'] = []
        this.$refs.maintainItemsRef.maintainUpdateFun([])
        if(form.type == 2){//设备保养状态默认为一级保养，并将工单内容开启编辑状态。
          form['maintain_name'] = "1" 
          this.$refs.maintainItemsRef.startEditing()

        }else{
          form['maintain_name'] = "" 
        }
      }
      if (fieldName == 'maintain_name') {
        form['save_maintain_item_ids'] = []
        this.$refs.maintainItemsRef.startEditing()  // 更改保养名称，并将工单内容开启编辑状态。
        this.$refs.maintainItemsRef.maintainUpdateFun([])
      }
      
      this.edit(form)
    },
    //编辑服务完成情况
    handleEdit(param,type){
      switch (type) {
        case 'complete_status':{
          
          const form = {
            id: this.woData.id,
            complete_status:param
          }
          this.edit(form)
        }
          break;
        case 'todo_list':{
          
          const form = {
            id: this.woData.id,
            todo_list:param
          }
          this.edit(form)
        }
          break;
        default:
          break;
      }
    },
    // 修改工单内容
    editContent(params) {
      const form = {
        id: this.woData.id,
        content: params.content,
        save_maintain_item_ids: params.maintain_items
      }

      this.edit(form)
    },
    // 修改设备
    editDevice(root_sn, { device_name, device_id }) {
      const form = {
        id: this.woData.id,
        device_root_sn: root_sn,
        device_name: device_name,
        device_id: device_id,
      }
      this.edit(form)
    },
    // 工单附件修改
    attachmentChange(ids) {
      const form = {
        id: this.woData.id,
        attachment: ids
      }
      this.edit(form)
    },
    // 现场签到修改
    checkInChange(ids) {
      // 有签到记录就修改已有的签到记录，没有就新建一条签到记录
      if (this.checkin && Object.keys(this.checkin).length) {
        this.checkin.attachment = ids
        editCheckin(this.checkin).then(() => {
          this.$emit('refresh')
        })
      } else {
        const param = {
          work_order: this.woData.id,
          attachment: ids,
          is_checkin: true
        }
        addCheckin(param).then(() => {
          this.$emit('refresh')
        })
      }
    },
    // 打开新增施工现场modal
    openAddWorkSiteModal(type) {
      if(type == 'construction_site'){
        this.$refs.addWorkSite.open()
      }else{
        this.$refs.addsiteDescription.open()
      }
    },
    // 施工现场修改
    workSiteChange() {
      //刷新获取详情
      this.$emit('refresh')
    },
    // 提交评价
    submitFeedback() {
      if (!this.feedBackForm.quality) {
        this.$message.error(this.$t('page.quality_required'))
        return
      }
      if (!this.feedBackForm.attitude) {
        this.$message.error(this.$t('page.attitude_required'))
        return
      }
      if (!this.feedBackForm.response_speed) {
        this.$message.error(this.$t('page.response_speed_required'))
        return
      }
      createCustomerFeedback(this.feedBackForm).then(() => {
        this.$message.success(this.$t('base.submit_success'))
        this.$emit('refresh')
      })
    },
    edit(params, go_back_list, reload=false) {
      editWorkOrder(params).then(res => {
        if(res.meta.code == 200){
          if (go_back_list){
            setTimeout(() => {
              this.$router.push('/work-order')
            }, 1000);
          }
          if (reload) {
            window.location.reload()
            return
          }
          /* 刷新整个页面的数据 */
          this.$emit('refresh')
          // this.editFieldName = '' //清除
        }
      })
    },
    /*获取联系人列表*/
    getCustomerContacts(){

        let params = {
            customer: this.woData.customer,
            label: '设备联系人' // 设备联系人
        }
        getCustomerContacts(params).then(res => {
            if (res && res.payload && res.payload.results) {

                this.userOptions = _.cloneDeep(res.payload.results)
                this.userOptions.forEach(item => {
                    item.label = item.name
                    item.value = item.id
                    item.disabled = false
                    if (item.id === this.woData.customer_contact) {
                        item.disabled = true
                    }

                })
            }
        }).catch(err => {
            console.log(err)
        }) 
    },
    // 获取联系人详情
    getCustomerContactDetail(id){
      getCustomerContactDetail(id).then(res => {
        this.customerContact = res.payload
      })
    },
    // 添加联系人
    addContactPerson() {
        let customer_id = this.woData.customer
        if (!customer_id) return errorMsg('belong_id 不存在！')
        this.addUpdateAccountDialogInfo = {
            visible: true,
            title: '新增联系人',
            formType: 'add', // 新增
            formData: {
                // role_id: null,
                email: null,
                username: null,
                first_name: null,
                last_name: null,
                tel: null,
                // tags: '',
                department: '',
                position: '',
                customer_id,
                // belong_type: 'customer',
            }
        }
    },            
    //修改联系人
    editContactPerson(){
      /* 获取设备联系人详情 */ 

      getCustomerDeviceContact(this.woData.customer_contact).then(res=>{
        if(res.meta.code == 200 && res.payload){
          let vl = res.payload || {}
        this.addUpdateAccountDialogInfo = {
          visible: true,
          title: '修改',
          formType: 'edit', // 新增
          id:this.woData.customer,
          disabledFields: ['username'], // 禁止编辑
          formData: {
            id:this.woData.customer_contact,
            customer_id:this.woData.customer,
            // role_id: vl.role_id,
            email: vl.email,
            username: vl.username,
            first_name: vl.first_name,
            last_name: vl.last_name,
            tel: vl.tel,
            // belong_id: vl.belong_id || '',
            // belong_type: vl.belong_type || '',
            tags: vl.tags,
            department: vl.department,
            position: vl.position
          }
        }
        }
      })
    },
    modalChange(){
      this.modalTitle = this.$t('page.work-order.contact')
      this.userModal = true
      this.contactPerson = '';
    },
    // 新增联系人成功回调，刷新页面
    addUpdateAccountSuccessed() {
     this.getCustomerContacts()
    },
    // 保存表单
    async saveForm(){
      //当派工时间未填写时
      if( this.modalTitle == this.$t('page.dispatch_confirmation') ){
        //校验是否填写完成。
        this.v$.planDate.$touch()
        const result = await this.v$.$validate()
        if (!result) {
          return;
        }
        let params = {
          id:this.woData.id,
          ...this.planDate
        }
        editWorkOrder(params).then(res => {
          if(res.meta.code == 200){
            this.toggleValue()//关闭派工确认弹框
            this.$emit('confirmOrder',true) //直接派工确认
          }
        }).catch(err => {
            console.log(err)
        })
      }else if(this.modalTitle == this.$t('page.work-order.contact')){

        this.userOptions.map(item => {
            if (this.contactPerson == item.id) {
                let params = {
                  id: this.woData.id,
                  customer_contact:item.id,
                  customer_contact_number:item.tel
                }
                // 修改普通工单的设备联系人
                editWorkOrder(params).then(res => {
                  if(res.meta.code == 200 && res.payload){
  
                    this.userModal = false
                    this.$nextTick(() => {
                      // 更新客户联系人信息
                      this.$emit('refresh')
                    })
                  }
  
                })
            }
        })
      }
    },
    //取消表单
    toggleValue(){
      this.userModal = ! this.userModal
    },
    /* 点击派工确认时,预计到场时间和预计完工时间 */ 
    inspectionTime(){
      this.modalTitle = this.$t('page.dispatch_confirmation')
      this.userModal = true
    },
  },
  components: {
    BusinessCard,
    SetCompanyModal,
    SetEngineerModal,
    AddWorkSite,
    AddSiteDescription,
    EditableField,
    UploadWithPreview,
    showAvatar,
    WoContentEditable,
    addUpdateAccountDialog,
    CheckedRadio,
    CustomerTextarea,
    flatPickr
  },
  watch: {
    woData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.currentCompanyId = val.service_company
        this.currentMainEngineerId = val.main_engineer
        this.currentAssistEngineerId = val.assist_engineer
        this.getCompany()
        this.getEngineer(this.currentCompanyId)
        this.getCustomerDetail()
        this.getCheckin()
        this.getWorkSite() //施工现场
        this.getSiteDescriptionInfo() //现场情况说明
        const root_sn = _.get(val, 'device_root_sn')
        this.deviceRootSn = root_sn

        if (root_sn) {
          this.getDeviceInfo(root_sn)
        }
        if (val.customer_contact) {
          // 获取联系人详情
          this.getCustomerContactDetail(val.customer_contact)
        }
        if (val.feedback) {
          this.feedBackForm = {...val.feedback, work_order: val.id}
        }


        if((val.customer_contact_name == "请完善")||(val.customer_contact_number== "请完善")){
          this.isAddEdit = false //修改状态
        }else{
          this.isAddEdit = true
        }

        //派工确认
        if(val.plan_start_at){
          this.planDate.plan_start_at = val.plan_start_at
        }
        if(val.plan_end_at){
          this.planDate.plan_end_at = val.plan_end_at
        }
      }
    }
  }
}
</script>
<template>
  <b-row align-v="stretch">
    <b-col>
      <b-card>
        <b-card-body>
          <div class="mb-3">
            <h5>{{ $t('page.work_order_progress') }}</h5>
          </div>
          <div class="progress progress-step-arrow progress-success">
            <a v-for="(item, index) in statusArr" :key="index" class="progress-bar" :class="getStatusProgressClass(item)" role="progressbar" style="width: 100%">{{ getStatusText(item) }}</a>
          </div>

          <b-row>
            <b-col class="mt-5" cols="12" md="auto">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.service_company') }}</p>
              <business-card v-if="currentCompanyId"
                             :target-id="currentCompanyId"
                             :title="currentCompany.name"
                             :tel="currentCompany.tel"
                             :icon="currentCompany.logo"
                             :editable="editableStatus && hasPermissionFor('order.company.patch') && taskServiceRequest"
                             :specialStatus="specialStatus"
                             @deleted="deleteCompany"
                             @exchange="this.showCompanySet = true"
              />
              <div v-else-if="editableStatus && hasPermissionFor('order.company.patch')" class="avatar-md align-self-center">
                <div class="avatar-title fs-16 rounded-circle bg-white border-dashed border text-muted text-opacity-50 cursor-pointer" @click="this.showCompanySet = true">
                  <span style="font-size: 3rem;color: #d3d3d3;">+</span>
                </div>
              </div>
              <set-company-modal :show="showCompanySet" @ok="editCompanyCommit"  @cancel="this.showCompanySet = false"></set-company-modal>
            </b-col>
            <b-col class="mt-5" cols="12" md="auto">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.engineer') }}</p>
              <b-row>
                <b-col cols="12" md="auto" v-if="currentMainEngineerId">
                  <business-card :target-id="currentMainEngineerId"
                                 :title="currentMainEngineer.name"
                                 :tel="currentMainEngineer.tel"
                                 :icon="currentMainEngineer.logo"
                                 :editable="editable && hasPermissionFor('order.engineer.patch')"
                                 @deleted="deleteEngineer('main')"
                                 @exchange="openEngineerSet('main')"
                  />
                </b-col>
                <b-col cols="12" md="auto" v-if="currentAssistEngineerId">
                  <business-card :target-id="currentAssistEngineerId"
                                 :title="currentAssistEngineer.name"
                                 :tel="currentAssistEngineer.tel"
                                 :icon="currentAssistEngineer.logo"
                                 :editable="editable && hasPermissionFor('order.engineer.patch')"
                                 @deleted="deleteEngineer('assist')"
                                 @exchange="openEngineerSet('assist')"
                  />
                </b-col>
                <b-col cols="12" md="auto" v-if="editable && hasPermissionFor('order.engineer.patch') && (!currentMainEngineerId || !currentAssistEngineerId)" class="d-flex">
                  <div class="avatar-md align-self-center">
                    <div class="avatar-title fs-16 rounded-circle bg-white border-dashed border text-muted text-opacity-50 cursor-pointer" @click="openEngineerSet('')">
                      <span style="font-size: 3rem;color: #d3d3d3;">+</span>
                    </div>
                  </div>
                </b-col>
                <set-engineer-modal :show="showEngineerSet" :compan-id="currentCompanyId" @ok="engineerChanged" @cancel="this.showEngineerSet = false"></set-engineer-modal>
              </b-row>
            </b-col>
          </b-row>
          <b-row cols="4">
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.customer_name') }}</p>
              <!-- :editable="editable && hasPermissionFor('order.other.patch') && !woData.task_id" -->
              <editable-field type="customer" 
                :editable="false"
                :value="woData.customer_txt" 
                custom-class="fs-14 mb-0" 
                @complete="editField($event,'customer')"></editable-field>
            </b-col>
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.expected-service-time') }}</p>
              <editable-field type="datetime" :editable="editable && hasPermissionFor('order.other.patch')" :value="woData.expectation_at" custom-class="fs-14 mb-0" @complete="editField($event,'expectation_at')"></editable-field>
            </b-col>
            <!-- 预计到场时间 -->
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.estimated_arrival_time') }}</p>
              <editable-field type="datetime" :editable="editable && hasPermissionFor('order.other.patch')" :value="woData.plan_start_at" custom-class="fs-14 mb-0" @complete="editField($event,'plan_start_at')"></editable-field>
            </b-col>
            <!-- 预计完工时间 -->
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.estimated_completion_time') }}</p>
              <editable-field type="datetime" :editable="editable && hasPermissionFor('order.other.patch')" :value="woData.plan_end_at" custom-class="fs-14 mb-0" @complete="editField($event,'plan_end_at')"></editable-field>
            </b-col>
          </b-row>
          <b-row cols="4">
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">
                {{ $t('page.work-order.device-root-sn') }}
                <span v-if="deviceInfo.product_type == 1 && deviceInfo.group_sn">（{{this.$t('page.unit_serial_number')}}：{{ deviceInfo.group_sn }}）</span>
              </p>
              <!-- :editable="editable && hasPermissionFor('order.other.patch') && !woData.task_id" -->
              <editable-field
                  type="device"
                  :value="deviceRootSn"
                  :editable="false"
                  :customer-id="woData.customer"
                  custom-class="fs-14 mb-0"
                  @complete="editDevice"
              ></editable-field>
            </b-col>
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.device_name') }}</p>
              <h5 class="fs-14 mb-0"><span>{{ woData.device_name }}</span></h5>
            </b-col>
<!--            <b-col class="mt-5">-->
<!--              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.unit_serial_number') }}</p>-->
<!--              <h5 class="fs-14 mb-0"><span>{{ deviceInfo.group_sn }}</span></h5>-->
<!--            </b-col>-->
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.locationOn') }}</p>
              <h5 class="fs-14 mb-0"><span>{{ deviceInfo.location }}</span></h5>
            </b-col>
          </b-row>
          <b-row cols="4">
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.work-order.type.text') }}</p>
              <editable-field
                type="type"
                :editable="editable && hasPermissionFor('order.other.patch')"
                :value="woData.type"
                :woData="woData"
                custom-class="fs-14 mb-0"
                @complete="editField($event,'type')"
              ></editable-field>
            </b-col>
            <b-col v-if="showMaintainInput" class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.work-order.type.maintenance-name')}}</p>
              <editable-field
                type="maintain_name"
                :editable="editable && hasPermissionFor('order.other.patch')"
                :value="woData.maintain_name"
                :woData="woData"
                custom-class="fs-14 mb-0"
                @complete="editField($event,'maintain_name')"
              ></editable-field>
            </b-col>
            <!-- 服务完成状态 -->
            <b-col class="mt-5">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.work-order.type.current-status')}}</p>
              <checked-radio
                custom-class="fs-14 mb-0"
                :editable="editable && hasPermissionFor('order.other.patch')"
                :value="woData.complete_status"
                :options="currentStatusOptions"
                @complete="handleEdit($event,'complete_status')"
              ></checked-radio>
            </b-col>
          </b-row>
          <b-row cols="4">
            <b-col class="mt-5" cols="12">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.work_order_content') }}</p>
              <wo-content-editable
                ref="maintainItemsRef"
                :editable="editable && hasPermissionFor('order.other.patch')"
                :content="woData.content"
                :maintain-options="maintainOptions"
                :maintain-item-ids="woData.maintain_item_ids || []"
                @complete="editContent"
                :editFieldName="editFieldName"
              ></wo-content-editable>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col cols="4">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.on_site_check_in') }}<span style="font-size: 0.8rem">（{{ $t('page.must operate on mobile') }}）</span></p>
              <div>{{ formatDatetime(checkin.check_in_time) }}</div>
              <div>{{ (checkin.address == '' || checkin.address == '-') ? $t('page.no_checkin_address') : checkin.address }}</div>
              <upload-with-preview
                  :value="checkin.attachment"
                  input-id="uploadCheckIn"
                  :multiple="true"
                  preview-type="thumb"
                  filename-prefix="checkin"
                  :showUploadBtn="false"
                  :canDelete="false"
              ></upload-with-preview>
            </b-col>
            <b-col>
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.initial_status') }}</p>
              <!--现场情况说明-->
              <upload-with-preview
                  :value="siteDescription"
                  input-id="uploadWorkSite"
                  :multiple="true"
                  preview-type="thumb"
                  filename-prefix="worksite"
                  :show-upload-btn="false"
                  :can-delete="false"
              ></upload-with-preview>
              <!--现场情况说明按钮 -->
              <div v-if="!isWorkOrderCompleted(woData) && hasPermissionFor('order.other.patch')" class="avatar-md align-self-center me-3" @click="openAddWorkSiteModal('initial_status')">
                <div class="avatar-title fs-16 rounded bg-white border-dashed border text-muted text-opacity-50 cursor-pointer">
                  <span style="font-size: 3rem;" class="text-body text-opacity-25">+</span>
                </div>
              </div>
              <!--现场情况说明模态框-->
              <AddSiteDescription ref="addsiteDescription" :work-id="woData.id" @complete="workSiteChange"></AddSiteDescription>
            </b-col>
            <b-col>
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.construction_site') }}</p>
              <!--施工现场图片文字查看 -->
              <upload-with-preview
                  :value="workSite"
                  input-id="uploadWorkSite"
                  :multiple="true"
                  preview-type="thumb"
                  filename-prefix="worksite"
                  :show-upload-btn="false"
                  :can-delete="false"
              ></upload-with-preview>
              <!--     添加施工现场按钮         -->
              <div v-if="!isWorkOrderCompleted(woData) && hasPermissionFor('order.other.patch')" class="avatar-md align-self-center me-3" @click="openAddWorkSiteModal('construction_site')">
                <div class="avatar-title fs-16 rounded bg-white border-dashed border text-muted text-opacity-50 cursor-pointer">
                  <span style="font-size: 3rem;" class="text-body text-opacity-25">+</span>
                </div>
              </div>
              <!--       添加施工现场模态框       -->
              <AddWorkSite ref="addWorkSite" :work-id="woData.id" @complete="workSiteChange"></AddWorkSite>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col cols="12">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.remaining_issus') }}</p>
              <customer-textarea
                custom-class="fs-14 mb-0"
                :editable="editable && hasPermissionFor('order.other.patch')"
                :value="woData.todo_list"
                :options="currentStatusOptions"
                @complete="handleEdit($event,'todo_list')"
              ></customer-textarea>
            </b-col>      
          </b-row>
          <b-row class="mt-5">
            <b-col cols="12">
              <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.work_order_attachments') }}</p>
              <b-row>
                <b-col>
                  <upload-with-preview
                      :value="woData.attachment"
                      input-id="uploadAttachment"
                      :multiple="true"
                      preview-type="card"
                      filename-prefix="wo"
                      :show-upload-btn="otherInfoEditPerm"
                      :can-delete="otherInfoEditPerm"
                      @changed="attachmentChange"
                  ></upload-with-preview>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

        </b-card-body>
      </b-card>
      <b-card v-if="woData.service_request">
        <b-card-header>
          <h5>{{ $t('page.customer_feedback') }}</h5>
        </b-card-header>
        <b-card-body>
          <p class="fw-semibold">{{ $t('page.problem_description') }}</p>
          <p class="text-muted">{{ woData.serviceRequestData ? woData.serviceRequestData.content : '' }}</p>
          <p class="fw-semibold">{{ $t('page.attachment') }}</p>
          <div>
            <upload-with-preview
                :value="woData.serviceRequestData ? woData.serviceRequestData.attachment : []"
                input-id="uploadServiceAttachment"
                :multiple="true"
                preview-type="thumb"
                filename-prefix="repair"
                :show-upload-btn="false"
                :can-delete="false"
            ></upload-with-preview>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col cols="3">


      <b-card no-body>
        <b-card-body class="p-4">
          <div>
            <div class="d-flex justify-content-center">
              <show-avatar :img-src="currentCustomer.logo" :title="woData.customer_txt" size="md"></show-avatar>
            </div>

            <div class="mt-4 text-center">
              <h5 class="mb-1">{{ woData.customer_txt }}</h5>
              <p class="text-muted">{{ $t(`['${currentCustomer.industry}']`) }}</p>
            </div>
            <div class="table-responsive">
              <table class="table mb-0 table-borderless">
                <tbody>
                <tr>
                  <th class="min-w-90"><span class="fw-medium">{{ $t('page.industry') }}</span></th>
                  <td>{{ $t(`['${currentCustomer.industry}']`) }}</td>
                </tr>
                <tr>
                  <th class="min-w-90"><span class="fw-medium">{{ $t('page.contact_number') }}</span></th>
                  <td>{{ woData.customer_contact_number }}</td>
                </tr>
                <tr>
                  <th class="min-w-90"><span class="fw-medium">{{ $t('page.email') }}</span></th>
                  <td>{{ currentCustomer.email }}</td>
                </tr>
                <tr>
                  <th class="min-w-90"><span class="fw-medium">{{ $t('page.homepage') }}</span></th>
                  <td>
                    <span>{{ currentCustomer.home_url }}</span>
                    <!--                    <b-link target="_blank" :href="currentCustomer.home_url" class="link-primary">{{ currentCustomer.home_url }}</b-link>-->
                  </td>
                </tr>
                <tr>
                  <th class="min-w-90"><span class="fw-medium">{{ $t('page.company_address') }}</span></th>
                  <td>
                    <div>
                      {{ addressText(currentCustomer) }}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <b-card no-body>
        <b-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title flex-grow-1 mb-0">{{ $t('page.contact') }}</h5>
            <div class="btn-wrap">
              <i v-if="isAddEdit" class="las la-exchange-alt cursor-pointer me-1" @click="modalChange()"></i>
              <i v-else class="ri-pencil-line cursor-pointer me-1" @click="editContactPerson()"></i>
            </div>
          </div>
        </b-card-header>
        <b-card-body>
          <ul class="list-unstyled mb-0 vstack gap-3">
            <li>
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <img src="@/assets/images/default-user.png" alt="" class="avatar-sm rounded" />
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="fs-14 mb-1">{{ customerContact.name }}</h6>
                  <p class="text-muted mb-0">{{ currentCustomer.name }}</p>
                </div>
              </div>
            </li>
            <li>
              <i class="ri-phone-line me-2 align-middle text-muted fs-16"></i>{{ customerContact.tel }}
            </li>
            <li v-if="customerContact.email">
              <i class="ri-mail-line me-2 align-middle text-muted fs-16"></i>{{ customerContact.email }}
            </li>
          </ul>
        </b-card-body>
      </b-card>
      <!-- 服务评价仅仅在工单已完成时展示 -->
      <b-card no-body v-if="isServiceEvaluation">
        <b-card-header>
          <div class="d-flex">
            <h5 class="card-title flex-grow-1 mb-0">{{ $t('page.serviceEvaluation') }}</h5>
          </div>
        </b-card-header>
        <b-card-body class="p-4">
          <div v-if="!woData.feedback" class="text-center py-5">
          <!-- <div v-if="!feedbackExist && !showFeedbackForm" class="text-center py-5">
            <p class="mb-4" v-show="isServiceEvaluation">{{ $t('page.please-evaluate') }}</p>
            <button class="btn btn-primary"  v-show="isServiceEvaluation" type="button" @click="showFeedbackForm = true">{{ $t('page.pending-evaluation') }}</button>
            <p class="mb-4" v-show="!isServiceEvaluation">{{ $t('page.no-evaluate') }}</p> -->
            <!-- web端仅仅做展示评分情况，不做操作 -->
            <p class="mb-4">{{ $t('page.no-evaluate') }}</p>
          </div>
          <div v-else class="table-responsive">
            <table class="table mb-0 table-borderless">
              <tbody>
              <tr>
                <th class="feedback-title"><span class="fw-medium" style="display: block;min-width: 60px;">{{ $t('page.serviceQuality') }}</span></th>
                <td class="d-flex align-items-baseline">
                  <el-rate v-model="feedBackForm.quality"
                      :disabled="feedbackExist"
                  />
                  <span :class="[feedBackForm.quality && 'rate-text-active']">{{ feedBackForm.quality ? rateTexts[parseInt(feedBackForm.quality)] : rateTexts[0] }}</span>
                </td>
              </tr>
              <tr>
                <th class="feedback-title"><span class="fw-medium">{{ $t('page.serviceAttitude') }}</span></th>
                <td class="d-flex align-items-baseline">
                  <el-rate v-model="feedBackForm.attitude"
                      :disabled="feedbackExist"
                  />
                  <span :class="[feedBackForm.attitude && 'rate-text-active']">{{ feedBackForm.attitude ? rateTexts[parseInt(feedBackForm.attitude)] : rateTexts[0] }}</span>
                </td>
              </tr>
              <tr>
                <th class="feedback-title"><span class="fw-medium">{{ $t('page.responseSpeed') }}</span></th>
                <td class="d-flex align-items-baseline">
                  <el-rate v-model="feedBackForm.response_speed"
                      :disabled="feedbackExist"
                  />
                  <span :class="[feedBackForm.response_speed && 'rate-text-active']">{{ feedBackForm.response_speed ? rateTexts[parseInt(feedBackForm.response_speed)] : rateTexts[0] }}</span>
                </td>
              </tr>
              <tr>
                <th><span class="fw-medium">{{ $t('page.customerMessage') }}</span></th>
                <td>
                  <el-input
                    v-if="!feedbackExist"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('page.feedback_content_placeholder')"
                    v-model="feedBackForm.content"
                  />
                  <div style="word-break: break-all;" v-else>{{ feedBackForm.content || '-' }}</div>
                </td>
              </tr>
              <tr>
                <th><span class="fw-medium">{{ $t('page.signature') }}</span></th>
                <td>
                  <img :src="feedBackForm.signature_file&&feedBackForm.signature_file.url" alt="" style="width: 9rem;height: 4.5rem;">
                </td>
              </tr>
              <tr>
                <th></th>
                <td>
                  <b-button v-if="!feedbackExist" variant="primary" @click="submitFeedback">{{ $t('page.feedback_submit') }}</b-button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card-body>
      </b-card>

    </b-col>
  </b-row>
  <!-- 添加联系人弹窗 -->
  <!-- type: user-普通用户 organization-企业用户 -->
  <addUpdateAccountDialog v-model:visible="addUpdateAccountDialogInfo.visible" v-bind="addUpdateAccountDialogInfo"
    type="organization" belong_type="customer" :disabledFields="['role_id']" defaultRoleCode="device_contact"
    @successed="addUpdateAccountSuccessed" />

  <!-- 选择编辑联系人列表 -->
  <el-dialog v-model="userModal" :title="modalTitle" width="30%" align-center>

        <div v-if="modalTitle == $t('page.work-order.contact')">
          <div class="d-flex flex-column align-items-end w-100">
            <!-- <button style="width:115px;" class="btn btn-primary mb-2" @click="addContactPerson()"><i class="ri-add-fill me-1"></i>
                          <span>添加联系人</span></button> -->
          </div>
            <div v-if="modalTitle == $t('page.work-order.contact')" class="input-light d-flex align-items-start justify-content-center"
                style="height:150px">
                <Multiselect class="form-control" :placeholder="$t('page.work-order.contact')" v-model="contactPerson" :close-on-select="true"
                    :searchable="false" :create-option="false" :options="userOptions" :can-clear="false" />
            </div>
        </div>

        <div v-if="modalTitle == $t('page.dispatch_confirmation')" style="padding: 0 20px;">
           <!-- 预计到场时间 -->
           <b-row class="mt-2">
              <p class="text-muted mb-2 fw-semibold"><span class="text-danger">*</span>{{ $t('page.estimated_arrival_time') }}</p>
              <flat-pickr ref="flatpickr" :class="v$.planDate.plan_start_at.$errors.length ? 'is-invalid' : ''" v-model="planDate.plan_start_at" :config="flatpickrConfig" :placeholder="this.$t('page.select-time')"
              class="form-control"/>
            </b-row>
            <!-- 预计完工时间 -->
            <b-row class="mt-2">
              <p class="text-muted mb-2 fw-semibold"><span class="text-danger">*</span>{{ $t('page.estimated_completion_time') }}</p>
              <flat-pickr ref="flatpickr" :class="v$.planDate.plan_end_at.$errors.length ? 'is-invalid' : ''" v-model="planDate.plan_end_at" :config="flatpickrConfig" :placeholder="this.$t('page.select-time')"
              class="form-control"/>
            </b-row>
        </div>
        <template #footer>
            <div class="dialog-footer d-flex justify-content-end">
                <button class="btn btn-light d-flex align-items-center" @click="toggleValue"><span>{{ $t('base.cancel') }}</span></button>
                <button class="btn btn-primary d-flex align-items-center ms-2"
                    @click="saveForm()"><span>{{ $t('base.confirm') }}</span></button>
            </div>
        </template>
  </el-dialog>
</template>
<style>
.feedback-title {
  vertical-align: middle;
  line-height: 32px;
}
.rate-text-active {
  color: #f7ba2a;
}
</style>
